import React from "react";
import { useNavigate } from "react-router-dom";
import arrowLeftWhite from "../assets/icons/arrow-left-white.svg";
import arrowLeftBlack from "../assets/icons/arrow-left-black.svg";

const BackButton = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // go to previous page
  };

  return (
    <div className="flex items-center">
      <button
        onClick={handleBack}
        className="max-xl:hidden flex items-center justify-center cursor-pointer"
      >
        <img
          src={arrowLeftWhite}
          alt="Go back"
          className="w-[20px] h-[20px] object-contain"
        />
      </button>
      <button
        onClick={handleBack}
        className="xl:hidden flex items-center justify-center cursor-pointer"
      >
        <img
          src={arrowLeftBlack}
          alt="Go back"
          className="w-[20px] h-[20px] object-contain"
        />
      </button>
    </div>
  );
};

export default BackButton;
